/** @jsxImportSource @emotion/react */
import React from 'react';

interface Props {
  sx?: React.CSSProperties;
}
const Arrow = ({ sx }: Props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      fill='none'
      viewBox='0 0 24 24'
      strokeWidth='1.5'
      stroke='currentColor'
      css={{ width: '28px', height: '28px', ...(sx ? sx : {}) }}
    >
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M19.5 8.25l-7.5 7.5-7.5-7.5'
      />
    </svg>
  );
};

export default Arrow;
